import * as yup from "yup";

export const loginFormValidator = yup.object().shape({
  // @TODO: Translation.
  username: yup.string().email().required("Username error"),
  password: yup.string().required("Password error"),
  remember: yup.boolean(),
});
